// extracted by mini-css-extract-plugin
export default {"link":"CustomLink_link__FeNmk"};